import { Shark, View } from "shark-mvc";

import templateContent from "./password-reset.html";

import messageModalComponent from "../../components/messageModal/messageModalComponent";
import signView from "../sign/signView";
import userManager from "../../managers/userManager";

class PasswordResetView extends View {
	constructor() {
		super("passwordResetView");

		this.setTemplate(templateContent);
	}
	
	beforeLoad () {
		Shark.set({
			resetPassordButtonCSSClasses: "",
			resetPassordButtonLabel: "Imposta Password",
		});
	}

	goBackToLoginViewBtn_clickHandler () {
		Shark.openPage(signView, { urlSearchParams: null });
	}

	init () {
		this.addComponents([messageModalComponent]);

		document.body.classList.add("theme-2");

		Shark.set({
			passwordHints: [],
		});
	}

	inputField_keyupHandler (event) {
		if (event.keyCode === 13) {
			this.setNewPassword();
		}
	}

	// passwordField_inputHandler () {
	// 	const currUser = Shark.get("currUser");
	// 	// currUser.password = document.querySelector("#passwordField").value;
	// 	this.validatePassword();
	// 	document.querySelector("#passwordField").focus();
	// }

	// passwordConfirmField_inputHandler () {
	// 	const currUser = Shark.get("currUser");
	// 	// currUser.__passwordConfirm = document.querySelector("#passwordConfirmField").value;
	// 	this.validatePassword();
	// 	document.querySelector("#passwordConfirmField").focus();
	// }

	validatePassword () {
		const currUser = Shark.get("currUser");
		// currUser.password = document.querySelector("#passwordField").value;
		const validationErrors = currUser.validate("setNewPassword");
		
		Shark.set({
			passwordHints: validationErrors,
		});
	}

	setNewPassword () {
		const currUser = Shark.get("currUser");
		const validationErrors = currUser.validateResetPassword();

		// console.log(validationErrors, currUser);

		if (validationErrors.length === 0) {
			Shark.set({
				resetPassordButtonCSSClasses: "disabled",
				resetPassordButtonLabel: "Attendi...",
			});
	
			userManager.setNewPassword(currUser)
			.then(setNewPasswordResponse => {
				// console.log({setNewPasswordResponse});
				if (setNewPasswordResponse.data.status === "success") {
					Shark.set({
						confirmSent: true,
					});

					Shark.render();
				}
				else {
					Shark.set({
						resetPassordButtonCSSClasses: "",
						resetPassordButtonLabel: "Imposta Password",
					});

					messageModalComponent.open("Attenzione, si è verificato un errore!<br><br>Probabilmente il link che hai usato non è più valido, prova a ripetere la procedura di recupero password.");
				}
			});
		}
		else {
			Shark.set({
				passwordHints: validationErrors.map(item => item.error),
			});
		}
	}

	setNewPasswordBtn_clickHandler () {
		this.setNewPassword();
	}

	setNewPasswordForm_submitHandler (event) {
		event.preventDefault();
		event.stopPropagation();

		return false;
	}
}

const passwordResetView = new PasswordResetView();

Shark.registerView(passwordResetView);

export default passwordResetView;
